export const getItem = (key: string) => {
    try {
        return window.localStorage.getItem(key);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const setItem = (key: string, value: string) => {
    try {
        return window.localStorage.setItem(key, value);
    } catch (err) {
        console.error(err);
    }
};

export const removeItem = (key: string) => {
    try {
        return window.localStorage.removeItem(key);
    } catch (err) {
        console.error(err);
    }
};

export const clear = () => {
    try {
        return window.localStorage.clear();
    } catch (err) {
        console.error(err);
    }
};
